import { render } from "./PreventivoSpostamentoInterno.vue?vue&type=template&id=42d24270&scoped=true"
import script from "./PreventivoSpostamentoInterno.vue?vue&type=script&lang=js"
export * from "./PreventivoSpostamentoInterno.vue?vue&type=script&lang=js"

import "./PreventivoSpostamentoInterno.vue?vue&type=style&index=0&id=42d24270&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d24270"]])

export default __exports__